<script setup lang="ts">
import { RouterView } from 'vue-router'
import CookieConsent from '@/components/CookieConsent.vue'
</script>

<template>
  <RouterView />
  <CookieConsent />
</template>

<style>
/* Global styles are imported in main.ts */
</style>
